const STAGE = process.env.REACT_APP_STAGE;

const includeFinancialStatements = STAGE !== 'removeFS';

const createMenuItem = (item) => ({ ...item });

const createMainHubMenu = () => ({
    name: 'Main Hub',
    inactive_img: '/images/main_hub_inscative.svg',
    active_img: '/images/main_hub_inscative.svg',
    parentKey: '/main-hub',
    url: '/main-hub/classes',
    children: [
        { name: 'Classes', url: '/main-hub/classes', roleKey: 'classes' },
        { name: 'Sections', url: '/main-hub/manage-sections', roleKey: 'sections' },
        { name: 'Subjects', url: '/main-hub/subjects', roleKey: 'subjects' },
        { name: 'Exams', url: '/student-master/exam', roleKey: 'exams' },
        { name: 'Class Association', url: '/employee-master/manage-association', roleKey: 'class-association' },
    ],
});

const createFeeManagementMenu = () => ({
    name: 'Fee Management',
    inactive_img: '/images/fee_managment_inactive.svg',
    active_img: '/images/fee_managment_inactive.svg',
    parentKey: '/fee-management',
    url: '/fee-management/fee-head',
    children: [
        { name: 'Fee Heads', url: '/fee-management/fee-head', roleKey: 'fee-heads' },
        { name: 'Fee Structures', url: '/fee-management/fee-structure', roleKey: 'fee-structures' },
        { name: 'Fee Terms', url: '/fee-management/fee-terms', roleKey: 'fee-terms' },
    ],
});

const createStudentMasterMenu = () => ({
    name: 'Students',
    inactive_img: '/images/student_master_inactive.svg',
    active_img: '/images/student_master_inactive.svg',
    parentKey: '/student-master',
    url: '/student-master/directory',
    children: [
        { name: 'Directory', url: '/student-master/directory?page_number=1&limit=10', roleKey: 'directory' },
        { name: 'Attendance', url: '/student-master/student-attendance', roleKey: 'students-attendance' },
        { name: 'Academic Reports', url: '/student-master/class-wise-academic-reports', roleKey: 'academic-reports' },
        { name: 'Invoices', url: '/student-master/invoice-list', roleKey: 'invoices' },
        { name: 'Collect Fee', url: '/student-master/collect-fee', roleKey: 'collect-fee' },
        { name: 'Fee Collection Report', url: '/student-master/fee-collection', roleKey: 'fee-collection-report' },
        { name: 'Promote Students', url: '/student-master/promote-history', roleKey: 'promote-students' },
        { name: 'Transfers', url: '/student-master/transfers', roleKey: 'transfers' },
    ],
});

const createNoticeBoardMenu = () => ({
    name: 'Notice Board',
    inactive_img: '/images/notice_board_inactive.svg',
    active_img: '/images/notice_board_inactive.svg',
    parentKey: '/noticeboard',
    url: '/noticeboard/classroom',
    children: [
        { name: 'Classroom', url: '/noticeboard/classroom', roleKey: 'classroom' },
        { name: 'Broadcasts', url: '/noticeboard/broadcasts', roleKey: 'broadcasts' },
    ],
});

const createEmployeeMasterMenu = () => ({
    name: 'Employees',
    inactive_img: '/images/employee_master_inactive.svg',
    active_img: '/images/employee_master_inactive.svg',
    parentKey: '/employee-master',
    url: '/employee-master/manage-employee',
    children: [
        { name: 'Directory', url: '/employee-master/manage-employee', roleKey: 'employee-directory' },
        { name: 'Attendance', url: '/employee-master/employee-attendance', roleKey: 'employees-attendance' },
        { name: 'Payroll', url: '/employee-master/payroll', roleKey: 'payroll' },
    ],
});

const createInventoryMasterMenu = () => ({
    name: 'Inventory',
    inactive_img: '/images/inventory_master_inactive.svg',
    active_img: '/images/inventory_master_inactive.svg',
    parentKey: '/inventory-master',
    url: '/inventory-master/inventory-list',
    children: [
        { name: 'Inventory', url: '/inventory-master/inventory-list', roleKey: 'inventory' },
        { name: 'Purchase Orders', url: '/inventory-master/purchase-order', roleKey: 'purchase-order' },
        { name: 'GRN Entry', url: '/inventory-master/grn-entry', roleKey: 'grn-entry' },
        { name: 'Inventory Stock Report', url: '/inventory-master/inventory-stock-report', roleKey: 'inventory-stock-report' },
        { name: 'Inventory Issue Report', url: '/inventory-master/inventory-issue-report', roleKey: 'inventory-issue-report' },
    ],
});

const createAccountingMenu = () => ({
    name: 'Accounting',
    inactive_img: '/images/accounting_inactive.svg',
    active_img: '/images/accounting_inactive.svg',
    parentKey: '/accounting',
    url: '/accounting/voucher-entry',
    children: [
        { name: 'Ledgers/Groups', url: '/main-hub/groups-ledgers', roleKey: 'ledgers/groups' },
        { name: 'Vouchers Entry', url: '/accounting/voucher-entry', roleKey: 'vouchers-entry' },
        { name: 'Payables', url: '/accounting/payables', roleKey: 'payables' },
    ],
});

const createFinancialStatementsMenu = () => ({
    name: 'Financial Statements',
    inactive_img: '/images/financial_statement_inactive.svg',
    active_img: '/images/financial_statement_inactive.svg',
    parentKey: '/financial-statements',
    url: '/financial-statements/balance-sheet',
    children: [
        { name: 'Balance Sheet', url: '/financial-statements/balance-sheet', roleKey: 'balance-sheet' },
        { name: 'Profit and Loss Sheet', url: '/financial-statements/profit-and-loss-sheet', roleKey: 'profit-and-loss-sheet' },
        { name: 'Trial Balance Sheet', url: '/financial-statements/trial-balance-sheet', roleKey: 'trial-balance-sheet' },
        { name: 'Receipts and Payments', url: '/financial-statements/receipts-and-payments', roleKey: 'receipts-and-payments' },
    ],
});

const createYearsMenu = (parentKey = '/manage-academic-years') => ({
    name: 'Years',
    inactive_img: '/images/years_active.svg',
    active_img: '/images/years_selected.svg',
    parentKey,
    url: '/manage-academic-years',
    children: [
        { name: 'Academic Years', url: '/manage-academic-years' },
        { name: 'Financial Years', url: '/manage-financial-years' },
    ],
});

const createHolidayManagementMenu = () => ({
    name: 'Holiday Management',
    inactive_img: '/images/holiday_active.svg',
    active_img: '/images/holiday_selected.svg',
    main_key: '/holiday-management',
    url: '/holiday-management',
    parentKey: '/holiday-management',
    roleKey: 'holiday-management',
});

const createProfileMenu = ({ landingUrl, profileLabel, profileUrl, includePayslips = false }) => ({
    name: 'Profile',
    active_img: '/images/profilelogo.svg',
    inactive_img: '/images/profilelogo.svg',
    parentKey: '/profile',
    url: landingUrl,
    children: [
        { name: 'My Profile', url: '/profile/my-profile' },
        { name: 'Update Password', url: '/profile/update-password' },
        ...(includePayslips
            ? [{ name: 'Payslips', url: '/profile/payslip' }]
            : [{ name: profileLabel, url: profileUrl }]),
    ],
});

const createBranchesMenu = (parentKey = '/manage-branches') => ({
    name: 'Branches',
    inactive_img: '/images/branches_inactive.svg',
    active_img: '/images/branches_inactive.svg',
    main_key: parentKey,
    url: '/manage-branches',
    parentKey,
});

const createInstitutionUsersMenu = () => ({
    name: 'Institution Users',
    inactive_img: '/images/institution-InstitutionUser.svg',
    active_img: '/images/institution-InstitutionUser.svg',
    main_key: '/manage-institution-users',
    url: '/manage-institution-users?page_number=1',
    parentKey: '/manage-institution-users',
});

const createSettingsMenu = () => ({
    name: 'Settings',
    inactive_img: '/images/settings_inactive.svg',
    active_img: '/images/settings_active.svg',
    parentKey: '/settings',
    url: '/settings/payment-gateway',
    roleKey: 'settings',
    openInNewTab: true,
});

const createNoBranchMenu = () => ([
    createProfileMenu({
        landingUrl: '/profile/institution-profile',
        profileLabel: 'Institution Profile',
        profileUrl: '/profile/institution-profile',
    }),
    createBranchesMenu('/'),
    createSettingsMenu(),
]);

const createBaseRoleMenus = ({
    profileMenu,
    yearsParentKey = '/manage-academic-years',
    includeHolidayManagement = false,
    includeSettings = false,
}) => {
    const menus = [
        createMainHubMenu(),
        createFeeManagementMenu(),
        createStudentMasterMenu(),
        createNoticeBoardMenu(),
        createEmployeeMasterMenu(),
        ...(includeHolidayManagement ? [createHolidayManagementMenu()] : []),
        createInventoryMasterMenu(),
        createAccountingMenu(),
    ];

    if (includeFinancialStatements) {
        menus.push(createFinancialStatementsMenu());
    }

    menus.push(
        createYearsMenu(yearsParentKey),
        profileMenu,
        createBranchesMenu(),
        ...(includeSettings ? [createSettingsMenu()] : []),
        createInstitutionUsersMenu(),
    );

    return menus;
};

const createInstitutionUserMenus = () =>
    createBaseRoleMenus({
        profileMenu: createProfileMenu({
            landingUrl: '/profile/institution-profile',
            profileLabel: 'Institution Profile',
            profileUrl: '/profile/institution-profile',
        }),
        includeHolidayManagement: true,
        includeSettings: true,
    });

const createInstitutionAdminMenus = () =>
    createBaseRoleMenus({
        profileMenu: createProfileMenu({
            landingUrl: '/profile/institution-profile',
            profileLabel: 'Institution Profile',
            profileUrl: '/profile/institution-profile',
        }),
        includeHolidayManagement: includeFinancialStatements,
        includeSettings: true,
    });

const createBranchUserMenus = () =>
    createBaseRoleMenus({
        profileMenu: createProfileMenu({
            landingUrl: '/profile/branch-profile',
            profileLabel: 'Branch Profile',
            profileUrl: '/profile/branch-profile',
        }),
        includeHolidayManagement: true,
        includeSettings: true,
    });

const createStaffUserMenus = () =>
    createBaseRoleMenus({
        profileMenu: createProfileMenu({
            landingUrl: '/profile/my-profile',
            profileLabel: 'My Profile',
            profileUrl: '/profile/my-profile',
            includePayslips: true,
        }),
        includeSettings: true,
    });

export let NavObj = {
    'institution-user': createInstitutionUserMenus().map(createMenuItem),
    'institution-admin': createInstitutionAdminMenus().map(createMenuItem),
    'branch-user': createBranchUserMenus().map(createMenuItem),
    'staff-user': createStaffUserMenus().map(createMenuItem),
    'no-branch': createNoBranchMenu().map(createMenuItem),
};
